"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var invariant_1 = __importDefault(require("invariant"));
var hw_app_tezos_1 = __importDefault(require("@ledgerhq/hw-app-tezos"));
var signOperation_1 = require("../../libcore/signOperation");
var buildBigNumber_1 = require("../../libcore/buildBigNumber");
var libcore_buildTransaction_1 = __importDefault(require("./libcore-buildTransaction"));
function signTransaction(_a) {
    var account = _a.account, transport = _a.transport, transaction = _a.transaction, coreTransaction = _a.coreTransaction, isCancelled = _a.isCancelled, onDeviceSignatureGranted = _a.onDeviceSignatureGranted, onDeviceSignatureRequested = _a.onDeviceSignatureRequested;
    return __awaiter(this, void 0, void 0, function () {
        var freshAddressPath, balance, id, subAccounts, hwApp, serialized, signature, hex, receiver, sender, recipients, _b, senders, feesRaw, fee, op, txHash, type, subAccount;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    freshAddressPath = account.freshAddressPath, balance = account.balance, id = account.id, subAccounts = account.subAccounts;
                    hwApp = new hw_app_tezos_1["default"](transport);
                    return [4 /*yield*/, coreTransaction.serialize()];
                case 1:
                    serialized = _c.sent();
                    onDeviceSignatureRequested();
                    return [4 /*yield*/, hwApp.signOperation(freshAddressPath, serialized)];
                case 2:
                    signature = (_c.sent()).signature;
                    onDeviceSignatureGranted();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, coreTransaction.setSignature(signature)];
                case 3:
                    _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, coreTransaction.serialize()];
                case 4:
                    hex = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, coreTransaction.getReceiver()];
                case 5:
                    receiver = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, coreTransaction.getSender()];
                case 6:
                    sender = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    if (!(transaction.mode === "undelegate")) return [3 /*break*/, 7];
                    _b = "";
                    return [3 /*break*/, 9];
                case 7: return [4 /*yield*/, receiver.toBase58()];
                case 8:
                    _b = _c.sent();
                    _c.label = 9;
                case 9:
                    recipients = [
                        _b
                    ];
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, sender.toBase58()];
                case 10:
                    senders = [_c.sent()];
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, coreTransaction.getFees()];
                case 11:
                    feesRaw = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, (0, buildBigNumber_1.libcoreAmountToBigNumber)(feesRaw)];
                case 12:
                    fee = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    txHash = "";
                    type = transaction.mode === "undelegate"
                        ? "UNDELEGATE"
                        : transaction.mode === "delegate"
                            ? "DELEGATE"
                            : "OUT";
                    subAccount = transaction.subAccountId && subAccounts
                        ? subAccounts.find(function (a) { return a.id === transaction.subAccountId; })
                        : null;
                    if (!subAccount) {
                        op = {
                            id: "".concat(id, "-").concat(txHash, "-").concat(type),
                            hash: txHash,
                            type: type,
                            value: transaction.useAllAmount ? balance : transaction.amount.plus(fee),
                            fee: fee,
                            blockHash: null,
                            blockHeight: null,
                            senders: senders,
                            recipients: recipients,
                            accountId: id,
                            date: new Date(),
                            extra: {}
                        };
                    }
                    else {
                        (0, invariant_1["default"])(subAccount.type === "ChildAccount", "tezos child account is ChildAccount");
                        op = {
                            id: "".concat(id, "-").concat(txHash, "-OUT"),
                            hash: txHash,
                            type: "OUT",
                            value: fee,
                            fee: fee,
                            blockHash: null,
                            blockHeight: null,
                            senders: senders,
                            recipients: [subAccount.address],
                            accountId: id,
                            date: new Date(),
                            extra: {},
                            subOperations: [
                                {
                                    id: "".concat(subAccount.id, "-").concat(txHash, "-").concat(type),
                                    hash: txHash,
                                    type: type,
                                    value: transaction.useAllAmount
                                        ? subAccount.balance
                                        : transaction.amount,
                                    fee: fee,
                                    blockHash: null,
                                    blockHeight: null,
                                    senders: senders,
                                    recipients: [transaction.recipient],
                                    accountId: subAccount.id,
                                    date: new Date(),
                                    extra: {}
                                },
                            ]
                        };
                    }
                    return [2 /*return*/, {
                            operation: op,
                            expirationDate: null,
                            signature: hex
                        }];
            }
        });
    });
}
exports["default"] = (0, signOperation_1.makeSignOperation)({
    buildTransaction: libcore_buildTransaction_1["default"],
    signTransaction: signTransaction
});
//# sourceMappingURL=libcore-signOperation.js.map